import React from 'react';
import { useTranslation } from 'react-i18next';
import { CloseCircle } from 'iconsax-react';
import Chip from '../../../components/atoms/Chip';
import { SupportTicket } from '../../../types/support';
import { formatCustomerType, getStatusType } from './utils';

interface TicketHeaderProps {
  ticket: SupportTicket;
  onClose?: () => void;
}

export const TicketHeader: React.FC<TicketHeaderProps> = ({
  ticket,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex justify-between items-start">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-full overflow-hidden shrink-0 border border-gray-100 bg-gray-100">
          <img
            src={ticket?.customerPhoto || ''}
            alt={ticket.customerName}
            className="w-full h-full object-fill"
          />
        </div>
        <div>
          <div className="flex items-center gap-1.5 flex-wrap">
            <h3 className="font-semibold text-light-text-primary text-lg leading-tight">
              {ticket.customerName || '---'}
            </h3>
            {ticket.customerType && (
              <span className="text-light-text-primary font-semibold text-lg">
                ({formatCustomerType(ticket.customerType, t)})
              </span>
            )}
          </div>
          <p className="text-light-text-primary mt-0.5">
            {ticket.customerEmail || '---'}
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3">
        <Chip
          type={getStatusType(ticket.status?.code)}
          className="!rounded-full px-3.5 py-1 text-xs font-medium"
        >
          {ticket.status?.code
            ? t(`support.${ticket.status.code}`, ticket.status?.name || '---')
            : ticket.status?.name || '---'}
        </Chip>

        {onClose && (
          <button
            type="button"
            onClick={onClose}
            className="p-1 rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors flex items-center justify-center cursor-pointer"
            aria-label={t('common.close', 'Close')}
          >
            <CloseCircle
              size={24}
              variant="Bold"
              className="text-light-text-primary dark:text-dark-text-primary hover:opacity-80 transition-opacity"
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default TicketHeader;
